import { NgModule } from '@angular/core';
import { MdbDraggableDirective } from './mdb-draggable.directive';

@NgModule({
  declarations: [MdbDraggableDirective],
  imports: [
  ],
  exports: [MdbDraggableDirective]
})
export class MdbDraggableModule { }
